{
    "PageTitle": "Boeking van vergaderruimtes / flexplek",
    "location": "Selecteer locatie / kamer",
    "date": "Datum",
    "from_date": "Van datum",
    "to_date": "Tot datum",
    "toDateError": "De 'Tot datum' moet gelijk zijn aan of later dan de 'Van datum' en het maximale verschil tussen de twee datums is 30 dagen.",
    "topic": "Onderwerp",
    "timeFrom": "Starttijd",
    "timeUntil": "Eindtijd",
    "startTime": "Starttijd",
    "capacity": "Hoeveel mensen zullen deelnemen?",
    "btnSubmit": "Verzenden",
    "btnReset": "Resetten",
    "formReset": "Formulier resetten",
    "errMsg": "Vul alstublieft alle velden in!",
    "inputPlaceholder": "invoer...",
    "hours": "uren",
    "minutes": "minuten",
    "starting": "Starten",
    "duration": "Duur",
    "btnSearch": "Zoeken",
    "locationOptionLabel": "Locatie, Kamernaam / Nummer",
    "startOptionLabel": "Selecteer starttijd",
    "durationOptionLabel": "Selecteer duur",
    "capacityOptionLabel": "Selecteer capaciteit",
    "searchText": "even geduld, we proberen verbinding te maken met de server!",
    "dummyLocationValueOne": "Locatie 1",
    "dummyLocationValueTwo": "Locatie 2",
    "roomAvailableTextDummy": "27 ruimtes gevonden voor 24 apr, 13:00 - 14:00 in Hallstadter Straße 119 - Schulungsgebäude",
    "roomAvailableFound": "Gevonden",
    "roomAvailableSpaces": "ruimtes op",
    "roomAvailablein": "in",
    "floorDropdownDummy": " EG Schulungsgebäude",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Vergaderlocatie",
    "titleOfMeetingLabel": "Vergadertitel",
    "titleOfMeetingPlaceholder": "Voer de titel of het onderwerp van de geplande vergadering in",
    "descOfMeetingPlaceholder": "Voeg beschrijving toe",
    "meetingDescriptionLabel": "Vergaderbeschrijving (optioneel)",
    "availableLabel": "Beschikbaar",
    "busyLabel": "Bezet",
    "confirmBookingBtn": "Boeking bevestigen",
    "bookingSuccessLabel": "Kamerboeking is succesvol",
    "bookingFailureLabel": "Er is iets misgegaan. Probeer het later opnieuw.",
    "selectRoomLocation": "Selecteer locatie / kamer",
    "futureDateError": "Selecteer alstublieft een juiste toekomstige datum/tijd.",
    "noSlotAvailable": "Geen beschikbare tijdsloten",
    "tokenRequired": "Vereiste toegangstoken ontbreekt of is verlopen.",
    "roomBooked": "Kamer is al geboekt!",
    "roomPartiallyBooked": "Kamer is gedeeltelijk geboekt!",
    "participantError": "U bent van plan te boeken voor ",
    "participantErrorMsg": " deelnemers, maar de kamer heeft slechts een capaciteit van ",
    "partiallyFree": "Gedeeltelijk vrij",
    "startingTime": "Starttijd",
    "participants": "Aantal deelnemers",
    "max": "Max",
    "capacityLabel": "Capaciteit ",
    "dashboard": "Toon mijn boekingen",
    "manageBookings": "Beheer boekingen",
    "bookAgain": "Opnieuw boeken",
    "cancelBookingConfrim": "Weet u zeker dat u deze vergadering wilt annuleren?",
    "list": "Lijst",
    "search": "Zoeken",
    "type": "Type",
    "updateBookingApiSucessMsg": "Boeking succesvol bijgewerkt",
    "rebookingApiSucessMsg": "Succesvol geboekt",
    "cancelBookingApiSucessMsg": "Boeking succesvol geannuleerd",
    "noUpcomingBooking": "U heeft momenteel geen aankomende boekingen",
    "noPastBooking": "U heeft momenteel geen eerdere boekingen",
    "apiFailDefaultMsg": "Er is iets misgegaan. Probeer het later opnieuw.",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "fieldRequired": "Dit veld is verplicht",
    "selectLocation": "Selecteer alstublieft locatie",
    "selectDate": "Selecteer alstublieft een datum voor de boeking",
    "meetingTitleMissing": "Vergadertitel ontbreekt",
    "numberOfParticipantMissing": "Aantal deelnemers ontbreekt",
    "gingcoDisclaimer": "MyHelp helpt bij een eenvoudige kamerboekingservaring. Voor andere Gingco-diensten (bijv.: Catering Services) kunt u contact opnemen met Gingco.",
    "availability": {
        "text": "Beschikbaarheid",
        "free": "Ja, beschikbaar",
        "busy": "Sorry, niet beschikbaar",
        "busyHint": "Probeer de datum of tijd te wijzigen, u kunt ook nabijgelegen kamers controleren",
        "partialFree": "Gedeeltelijk vrije kamer",
        "unknown": "Onbekend"
    },
    "manageBooking": {
        "meetingLocation": "Vergaderlocatie",
        "reschedule": "Verzetten",
        "bookAgain": "Opnieuw boeken",
        "rescheduleTo": "Verzetten naar",
        "cancelMeeting": "Vergadering annuleren",
        "searchPlaceholder": "Zoeken op Vergader-ID, Beschrijving, Locatie"
    },
    "durationOptions": {
        "15 Min": "15 Min",
        "30 Min": "30 Min",
        "45 Min": "45 Min",
        "1 Hr": "1 Uur",
        "2 Hr": "2 Uur",
        "4 Hr": "4 Uur",
        "8 Hr": "8 Uur"
    },
    "meetingRoomTypes": {
        "All": "Alle",
        "Hot Desk": "Hot Desk",
        "Meeting Room": "Vergaderruimte"
    },
    "peopleCount": "Hoeveel personen nemen deel?"
}